import { EnterpriseClassification, EntityLabel } from '@esg/esg-global-types';
import { GET_ENTERPRISE_CLASSIFICATION_QUERY } from '../graphql/queries/enterprise_classification';
import { apollo_client } from './db_util';
import { MetadataError } from '@ep/error-handling';
import { generateUuidV4 } from '../../util/uuid';

export const enterprise_classification_label: EntityLabel = {
  one: 'Enterprise Classification',
  many: 'Enterprise Classifications'
};

/**
 * Function to query all Enterprise Classification docs from master list in firestore.
 * @returns {Array<EnterpriseClassification>}
 */
export const getEnterpriseClassifications = async () => {
  try {
    const enterprise_classifications: Array<EnterpriseClassification> = await apollo_client
      .query({
        query: GET_ENTERPRISE_CLASSIFICATION_QUERY,
        fetchPolicy: 'no-cache'
      })
      .then((response) => response.data.enterprise_classifications);
    return enterprise_classifications;
  } catch (err: unknown) {
    const tracking_id: string = generateUuidV4();
    throw new MetadataError(
      err instanceof Error
        ? err.message
        : 'Error: getEnterpriseClassifications failed on an unknown error',
      {},
      tracking_id
    );
  }
};
